import { ServicePage } from "@/components/ServicePage";

const WageStudies = () => (
  <ServicePage
    testid="wage-studies-page"
    overline="Wage & Market Studies"
    titleLines={["Pay bands", "that hold up."]}
    image="/generated/wage-studies.png"
    startingAt="Starting at $3,500"
    intro="A wage scale is only as strong as the logic behind it. I build comparator-based and public-sector wage studies that stand up to scrutiny, from BOLI to your own board."
    defaultService="wage-studies"
    steps={[
      { t: "Job architecture", d: "We clarify job descriptions and levels so comparisons are apples to apples." },
      { t: "Comparator selection", d: "We choose defensible market and public-sector comparators tailored to your region and sector." },
      { t: "Bands & movement rules", d: "We deliver transparent pay bands with documented movement logic you can actually administer." },
    ]}
    proofPoints={[
      { stat: "Comparator-based", label: "The rigorous, public-sector-grade methodology, available to any employer." },
      { stat: "Defensible", label: "Every band decision is documented, your best answer when someone asks 'why'." },
      { stat: "ORS-aligned", label: "Structured pay bands are a frontline defense under ORS 652.220." },
    ]}
    faqs={[
      { q: "Do I need a wage study if I'm doing a pay-equity audit?", a: "They pair well. The audit finds today's gaps; the wage study builds the structure that prevents new ones. Many clients do both." },
      { q: "Is this only for the public sector?", a: "No. Comparator-based methodology comes from the public sector, but private employers get the same rigor and defensibility." },
      { q: "What's the starting price?", a: "Studies begin at $3,500 and scale with the number of roles and comparators. You'll get a firm quote on your call." },
    ]}
  />
);

export default WageStudies;
